/**
 * @module stimulusCard
 */

const React = require('react');
const SharedModels = require('../../../shared/sharedModels');
const SharedConstants = require('../../../shared/sharedConstants');
const connect = require('react-redux/dist/react-redux.min.js').connect;
const ReduxStore = require('./redux/reduxStore.jsx.js');
const OneLineTextField = require('./components/commonControls.jsx.js').OneLineTextField;
const MultiLineTextField = require('./components/commonControls.jsx.js').MultiLineTextField;
const CardContentTopRow = require('./components/commonCardControls.jsx.js').CardContentTopRow;
const CardTopics = require('./components/commonCardControls.jsx.js').CardTopics;
const CardContentBodyField = require('./components/commonCardControls.jsx.js').CardContentBodyField;
const CardConnections = require('./components/commonCardControls.jsx.js').CardConnections;
const CardVotes = require('./components/commonCardControls.jsx.js').CardVotes;
const CardComments = require('./components/cardComments.jsx.js').CardComments;
const AjaxFunctions = require('./ajaxFunctions.js');
const baseURL = window.location.origin;

class CardMainContainer extends React.Component{
   constructor(props) {
      super(props);
   }

   componentDidMount() {
      if(!ReduxStore.isStimulusCardSet() && window.globals.idCard){
         $.get( baseURL + "/stimulus/getByID?id=" + window.globals.idCard, (data) => {
            ReduxStore.store.dispatch(ReduxStore.StimulusCardFunctions.setCurrentCard(new SharedModels.StimulusCard(data)));
         })
            .fail(function(err) {
               alert(err);
            });
      }
   }

   render() {
      let topRow = (this.props.isEditing ? '' : <StimulusCardContentTopRow />);
      let cardVotes = (this.props.isEditing ? '' : <StimulusCardVotes />);
      let comments = (this.props.isEditing ? '' : <StimulusCardComments />);
      return (
         <div className='container-fluid'>
            <row>
               <div className='container-fluid stimulus card-full'>
                  <div className='row'>
                     <div className='col-sm-12'>
                        <div className='hexagon card-icon-container'>
                           <i className="fa fa-2x fa-bolt" />
                           <svg className="hexagon float" xmlns="http://www.w3.org/2000/svg" width="102" height="102" viewBox="0 0 102 102">
                              <title>Polygon</title>
                              <g fill="none">
                                 <g fill="#4357CF">
                                    <polygon points="36 0 67.2 18 67.2 54 36 72 4.8 54 4.8 18"/>
                                 </g>
                              </g>
                           </svg>
                        </div>
                        <h4 className="stimulus float">Stimulus</h4>
                        {topRow}
                        <div className='card-article'>
                           <StimulusCardContentBodyMainView cardData={this.props.cardData} />
                        </div>
                        {cardVotes}
                        <StimulusCardTopics />
                     </div>
                  </div>
               </div>
               <StimulusCardConnections />
            </row>
            {comments}
         </div>
      );
   }
}

const mapCardMainContainerStateToProps = (state) => {
   return {
      isEditing: state.EditorReducer.isEditing,
   }
};

export default connect(
   mapCardMainContainerStateToProps,
   () => {}
)(CardMainContainer);

const mapCardConnectionsStateToProps = (state) => {
   return {
      cards: state.StimulusCardReducer.curCard.evidenceCards || [],
      link: '/connectionsView?idCard=' + state.StimulusCardReducer.curCard.id + '&cardType=stimulus'
   }
};

const mapCardConnectionsDispatchToProps = () => {
   return {
   }
};

const StimulusCardConnections = connect(
   mapCardConnectionsStateToProps,
   mapCardConnectionsDispatchToProps
)(CardConnections);

class StimulusCardContentBody extends React.Component{
   constructor(props) {
      super(props);
   }

   deleteCard(){
      $.post( baseURL + "/stimulus/delete", {data: this.props.curCard.id}, function() {
         window.location.href = '/';
      })
         .fail(function(msg) {
            alert(msg.responseText);
         });
   }

   render() {
      let doneButton = () => {
         if(!this.props.isEditing){
            return '';
         }
         else{
            return(
               <button className='btn btn-primary' onClick={this.props.doneEditing}>Done</button>
            )
         }
      };

      let deleteButton = () => {
         if(!window.globals.isAdmin  || this.props.isEditing){
            return '';
         }
         else{
            return(
               <button className='btn btn-danger' onClick={() => this.deleteCard()}>Delete</button>
            )
         }
      };
      const titleField = () => {
         let placeholderText = 'Summarize some issue, evidence, or thought we should care about';
         return(
            <OneLineTextField
               data={this.props.curCard.title}
               isEditing={this.props.isEditing}
               onChange= {this.props.onChange}
               dataField= 'title'
               checkForValidationErrors={this.props.checkForValidationErrors}
               placeholder={placeholderText}
            />
         )
      };
      const synopsisField = () => {
         let placeholderText = `Exposition, Abstraction, etc.`;
         return(
            <MultiLineTextField
               data={this.props.curCard.synopsis}
               isEditing={this.props.isEditing}
               onChange= {this.props.onChange}
               dataField= 'synopsis'
               checkForValidationErrors={this.props.checkForValidationErrors}
               placeholder={placeholderText.replace(/(\r\n|\n|\r)/gm," ")}
               maxLength='500'
            />
         )
      };
      return(
         <div className='card-content-body-fields'>
            <CardContentBodyField
               title="Headline"
               data={titleField()}
            />
            <CardContentBodyField
               title="Body Of Text"
               data={synopsisField()}
            />
            {doneButton()}
            {deleteButton()}
         </div>
      );
   }
}

const mapStimulusCardContentBodyStateToProps = (state) => {
   return {
      isEditing: state.EditorReducer.isEditing,
      curCard: state.StimulusCardReducer.curCard,
      checkForValidationErrors: state.EditorReducer.checkForValidationErrors
   }
};

const mapStimulusCardContentBodyDispatchToProps = (dispatch) => {
   return {
      doneEditing: () => {
         const cardToSave = ReduxStore.store.getState().StimulusCardReducer.curCard;
         if(cardToSave.hasValidationErrors()){
            dispatch(ReduxStore.EditorFunctions.setCheckForValidationErrors(true));
            return;
         }
         dispatch(ReduxStore.EditorFunctions.setCheckForValidationErrors(false));

         AjaxFunctions.createStimulusCard(cardToSave).then((data) => {
            window.location.href = '/stimulusCard?idCard=' + data.idStimulusCard;
         });
      },

      onChange: (event,dataField) => {
         dispatch(ReduxStore.StimulusCardFunctions.setCurrentCardField(dataField, event.target.value));
      }
   }
};

const StimulusCardContentBodyMainView = connect(
   mapStimulusCardContentBodyStateToProps,
   mapStimulusCardContentBodyDispatchToProps
)(StimulusCardContentBody);



const mapCardContentTopRowStateToProps = (state) => {
   return {
      cardType: 'Stimulus',
      creator: state.StimulusCardReducer.curCard.creator,
      creationTime: state.StimulusCardReducer.curCard.creationTime,
      CardTopicControl: () => {return (<StimulusCardTopics />)}
   }
};

const StimulusCardContentTopRow = connect(
   mapCardContentTopRowStateToProps,
   (dispatch, ownProps) => {}
)(CardContentTopRow);

const mapCardTopicsStateToProps = (state) => {
   return {
      topicList: state.StimulusCardReducer.curCard.topics,
      isEditing: state.EditorReducer.isEditing,
      allTopics: state.EditorReducer.allTopics,
      popoverControl: (props) => {
         return(<StimulusCardTopicsEditorPopover
            curTopics={props.topicList}
            allTopics={props.allTopics}
            addFunction={props.addTopicFunction}
            removeFunction={props.removeTopicFunction}
         />)
      }
   }
};

const mapCardTopicsDispatchToProps = (dispatch) => {
   return {
      addTopicFunction: (topic) => {
         dispatch(ReduxStore.StimulusCardFunctions.addTopicToCurrentCard(topic));
      },

      removeTopicFunction: (topic) =>{
         dispatch(ReduxStore.StimulusCardFunctions.removeTopicFromCurrentCard(topic));
      }
   }
};

const StimulusCardTopics = connect(
   mapCardTopicsStateToProps,
   mapCardTopicsDispatchToProps
)(CardTopics);

const mapCardVotesStateToProps = (state) => {

   return {
      upVoteCount: state.StimulusCardReducer.curCard.votes.strongVoteCount,
      downVoteCount: state.StimulusCardReducer.curCard.votes.weakVoteCount,
      curUserVote: state.StimulusCardReducer.curCard.vote
   }
};

const mapCardVotesDispatchToProps = (dispatch) => {
   return {
      upVoteFunction: () => {
         let cardType = SharedConstants.CardType.Stimulus;
         let curCardId = ReduxStore.store.getState().StimulusCardReducer.curCard.id;
         AjaxFunctions.castCardVote(cardType, curCardId, SharedConstants.VoteType.UpVote).then(
            (newData) => {
               dispatch(ReduxStore.StimulusCardFunctions.setCurrentCard(newData.card));
            }
         );
      },
      downVoteFunction: () => {
         let cardType = SharedConstants.CardType.Stimulus;
         let curCardId = ReduxStore.store.getState().StimulusCardReducer.curCard.id;
         AjaxFunctions.castCardVote(cardType, curCardId, SharedConstants.VoteType.DownVote).then(
            (newData) => {
               dispatch(ReduxStore.StimulusCardFunctions.setCurrentCard(newData.card));
            }
         );
      }
   }
};

const StimulusCardVotes = connect(
   mapCardVotesStateToProps,
   mapCardVotesDispatchToProps
)(CardVotes);

const mapCardCommentsStateToProps = (state) => {

   return {
      comments: state.StimulusCardReducer.curCard.comments,
   }
};

const mapCardCommentsDispatchToProps = () => {
   return {
      onSubmit: (commentText, onSubmitCallback) => {
         let idCard = ReduxStore.store.getState().StimulusCardReducer.curCard.id;

         let callbackWrapper = () =>{
            onSubmitCallback();
            let getCardCallback = (data) =>{
               ReduxStore.store.dispatch(ReduxStore.StimulusCardFunctions.setCurrentCard(new SharedModels.StimulusCard(data)));
            };
            AjaxFunctions.getStimulusCardByID(idCard).then(getCardCallback);
         };
         console.error('returned data will not be in the form expected here. See evidence for a working example');
         AjaxFunctions.createCardComment(SharedConstants.CardType.Stimulus, idCard, null, commentText).then(callbackWrapper);
      },
   }
};

const StimulusCardComments = connect(
   mapCardCommentsStateToProps,
   mapCardCommentsDispatchToProps
)(CardComments);